type AuthState = {
  jwt: string | null;
  account: string | null;
};

export const useAuthState = useState("auth", (): AuthState => {
  return {
    account: null,
    jwt: "",
  };
});
